export default function Arrow() {
  return (
    <path
      fill="currentColor"
      d="M36.215 22.033L15.688.828C14.63-.264 12.896-.278 11.82.798c-.523.524-.814 1.225-.82 1.973-.006.748.275 1.454.79 1.986l18.625 19.24-18.625 19.24c-.515.534-.796 1.24-.79 1.989.006.748.297 1.448.82 1.973.517.515 1.198.8 1.92.8.738 0 1.43-.296 1.948-.832L36.215 25.96c1.047-1.083 1.047-2.845 0-3.928"
    />
  )
}
